import React, { useMemo, useState } from 'react';
import AnsweredGridPreview from '../shared/AnsweredGridPreview';
import ZoomedImagePreview from '../shared/ZoomedImagePreview';
import CustomPrivateShareCardModal from './CustomPrivateShareCardModal';
import './CustomGameModal.css';

const toModalCopy = (status) => {
  if (status === 'solved') {
    return {
      title: 'You solved this custom puzzle!',
      message: 'Great work. Share your result without revealing the answer.',
    };
  }
  if (status === 'revealed') {
    return {
      title: 'Answer revealed',
      message: 'You can still share the image card without revealing the answer.',
    };
  }
  return {
    title: 'Custom game complete',
    message: 'No worries. You can still share a spoiler-free image card.',
  };
};

const CustomGameModal = ({
  status,
  isGridStyle,
  imageUrl,
  solution,
  guesses = [],
  maxGuesses,
  shareZoomLevel,
  shareZoomOrigin,
  gameSlug = '',
  onClose,
  onHome,
}) => {
  const [showPrivateShareModal, setShowPrivateShareModal] = useState(false);
  const { title, message } = useMemo(() => toModalCopy(String(status || '')), [status]);
  const gridGuessWords = useMemo(
    () =>
      (Array.isArray(guesses) ? guesses : [])
        .map((entry) => String(entry?.word || '').trim().toUpperCase())
        .filter(Boolean),
    [guesses],
  );

  if (showPrivateShareModal) {
    return (
      <CustomPrivateShareCardModal
        imageUrl={imageUrl}
        shareZoomLevel={shareZoomLevel}
        shareZoomOrigin={shareZoomOrigin}
        guesses={guesses}
        solution={solution}
        isGridStyle={isGridStyle}
        maxGuesses={maxGuesses}
        gameSlug={gameSlug}
        onClose={() => setShowPrivateShareModal(false)}
        onHome={onHome}
      />
    );
  }

  return (
    <div className="modal-overlay">
      <div className="modal-content game-result-modal game-result-modal--scrollbar custom-game-modal">
        <h2>{title}</h2>
        <div className="modal-image-container game-result-modal__media">
          <ZoomedImagePreview
            imageUrl={imageUrl}
            alt={solution || 'Custom puzzle'}
            zoomLevel={100}
            zoomOrigin={null}
            size={240}
            borderRadius={10}
          />

          {solution ? (
            <p>
              Word: <strong>{String(solution).toUpperCase()}</strong>
            </p>
          ) : null}

          <p className="custom-game-modal__message">{message}</p>

          <button
            type="button"
            className="definition-button"
            onClick={() => setShowPrivateShareModal(true)}
            disabled={!imageUrl || !solution}
          >
            Share without revealing answers
          </button>

          {isGridStyle ? <AnsweredGridPreview guesses={gridGuessWords} solution={solution} /> : null}
        </div>

        <div className="custom-game-modal__actions">
          <button type="button" className="custom-game-modal__nav-btn" onClick={onClose}>
            Close
          </button>
          <button
            type="button"
            className="custom-game-modal__nav-btn custom-game-modal__nav-btn--primary"
            onClick={onHome}
          >
            Home
          </button>
        </div>
      </div>
    </div>
  );
};

export default CustomGameModal;
